var dom = {
    size: () => {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }
}